import { request } from "hooks/useOkoApi/useOkoApi";

const BASE = "admin/teacher-reports-metrics";

export const fetchWaitTimes = ({ startDate, endDate, granularity, measurement, reports }) =>
  request(
    `${BASE}/wait-times?start_date=${startDate}&end_date=${endDate}&granularity=${granularity}&measurement=${measurement}&reports=${reports}`,
    { method: "GET" }
  );

export const fetchSessions = ({ startDate, endDate }) =>
  request(`${BASE}/sessions?start_date=${startDate}&end_date=${endDate}`, { method: "GET" });

// No retry: a 5xx can leave the report already processing, and a second POST would then answer 409.
export const startReport = (sessionId) =>
  request(`${BASE}/sessions/${sessionId}/report`, { method: "POST", maxRetries: 0 });
